import React from "react";

function Spinner({ position }) {
  return (
    <div className="spinner">
      <div style={{position}} className="spinner__icon"></div>
    </div>
  );
}

export default Spinner;